import { Locale } from '../../../../core/i18n/Locale';
import { handleResponse } from '../../../shared/api/handleResponse';
import { buildPyriteRequest } from '../../../shared/api/pyrite/url';

import { NormalizedUserFromPyrite, normalizeUserFromPyrite, UserFromPyrite } from './normalizer';

type FetchUserFromPyriteResponse = {
    user: UserFromPyrite;
};

async function fetchUserFromPyrite(
    locale: Locale,
    jwt?: string,
): Promise<FetchUserFromPyriteResponse> {
    const { url, forwardedHost } = buildPyriteRequest('api_user', locale);

    const headers: Record<string, string> = {};
    if (jwt) {
        headers.Cookie = `evaneos_auth_token=${jwt}`;
    }
    // Pyrite routes by host, but fetch drops the `Host` header on a service-to-service URL,
    // so the market host is forwarded explicitly (without it Pyrite answers 301 instead of 200).
    if (forwardedHost) {
        headers['X-Forwarded-Host'] = forwardedHost;
        headers['X-Forwarded-Proto'] = 'https';
    }

    const response = await fetch(url, {
        credentials: 'same-origin',
        headers: Object.keys(headers).length > 0 ? headers : undefined,
    });

    return handleResponse<FetchUserFromPyriteResponse>(response);
}

export async function getUserFromPyrite(
    locale: Locale,
    jwt?: string,
): Promise<NormalizedUserFromPyrite> {
    const { user } = await fetchUserFromPyrite(locale, jwt);

    return normalizeUserFromPyrite(user);
}
